import React from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'reactstrap'
import BarChart from '../../../components/charts/BarChart'

function PageViews({ total, loading }) {
  const [t] = useTranslation()

  return (
    <div className='page-views analytics card'>
      {
        loading ? <Spinner size="md" className="m-auto text-center" color="success" /> : <>
          <h2 className='number'>{(total)?.toLocaleString(undefined, { maximumFractionDigits: 2 })} </h2>
          <p>{t('Page Views')}</p>
          <BarChart name="Page Views" />
        </>
      }
    </div>
  )
}

export default PageViews